import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { rem } from '@mantine/core';
import styled from 'styled-components';
import { ITextProps } from '@dealstack/frontend/shared/components/fundament/Text/Text.types';

export const Container = styled.div<{ width?: string }>`
	width: ${({ width }) => width ?? '100%'};
`;

export const SearchSelectWithNestedCollapsableChildrenContainer = styled.div`
	position: relative;
	width: 100%;
`;

export const DisplaySelectedItemsContainer = styled.div`
	display: flex;
	background-color: ${(props) => props.theme.v3.colors.white[0]};
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	border-radius: 4px;
	padding: 0.3rem 0.5rem;
	width: 100%;
	cursor: pointer;
`;

export const OverlayContainer = styled.div<{ isOpen?: boolean }>`
	position: relative;
	display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
	background: white;
	padding: 0.2rem 0;
	border-radius: ${rem(8)};
	box-shadow: 0 0 ${rem(10)} rgba(0, 0, 0, 0.2);
	max-height: ${rem(400)};
	overflow-y: auto;
	z-index: 1;
	margin-top: ${rem(3)};
	width: 100%;
`;

export const Title = styled.span`
	margin: 0 0 0.2rem 0.1rem;
	font-weight: 600;
	font-size: ${rem(11)};
	display: inline-block;
`;

export const NestedCheckboxWrapper = styled.div<{ level: number }>`
	margin-left: ${({ level }) => `${rem(level * 16)}`};
`;

export const NestedCheckboxInnerWrapper = styled.div`
	margin-top: ${rem(4)};
`;

export const NestedCheckBoxInnerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: ${rem(8)};
`;

export const NestedCheckBoxButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: ${rem(2)};
	display: flex;
	align-items: center;
`;

export const DisplayCaretContainer = styled.div`
	margin: auto 0.4rem auto auto;
	padding-top: 0.1rem;
`;

export const NestedCheckboxContainer = styled.div`
	overflow-y: auto;
	max-height: ${rem(300)};
`;

export const StyledText = styled(Text).attrs<Partial<ITextProps>>((props: ITextProps) => props)`
	color: ${({ theme }) => theme.color.greys[500]};
	margin: auto 0 auto 0.5rem;
`;
